import styled from '@themes/theme'
import { preventScrollStyle } from '@styles/base.style'

export const liveScoreH = 98

export const ChatLiveScoreWrap = styled.div`
  position: absolute;
  top: -${liveScoreH}px;
  left: 0;
  width: 100%;
  height: ${liveScoreH}px;
  ${preventScrollStyle};
  .add-match-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    width: 100%;
    height: 100%;
    color: ${props => props.theme.color.modalTxt};
    font-size: ${props => props.theme.font.large};
    background: ${props => props.theme.color.themeTxt};
    border-radius: 0;
    border-bottom: 1px solid ${props => props.theme.color.modalSubBg};
    .live-txt-img {
      width: 100%;
      height: auto;
      overflow: hidden;
      object-fit: cover;
      transform: translate3d(0, 0, 0);
    }
  }
`
export const SelectedMatch = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  background: ${props => props.theme.color.modalSubBg};
  overflow-x: auto;
  .selected-match-item {
    position: relative;
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: center;
    min-width: 118px;
    width: 118px;
    margin: 6px 3px;
    height: calc(${liveScoreH}px - 12px);
    color: ${props => props.theme.color.modalTxt};
    font-size: ${props => props.theme.font.small};
    background: ${props => props.theme.color.themeTxt};
    //border: 1px solid #D7D9DC;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px #00000007;
    &:first-of-type {
      margin-left: 9px;
    }
    &.show-timeline {
      border: 2px solid ${props => props.theme.color.select};
      box-sizing: content-box;
      margin-top: 4px;
    }
    // 채팅 라이브스코어 내 타임라인 출력버튼
    .match-record-btn {
      position: absolute;
      opacity: 0;
      width: 100%;
      height: calc(100% - 27px);
      top: 27px;
      left: 0;
    }
    .selected-match-header {
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 27px;
      padding: 0 7px;
      font-size: ${props => props.theme.font.small};
      font-weight: ${props => props.theme.fontW.medium};
      background: ${props => props.theme.color.subBg};
      .sports-ico {
        img {
          width: 14px;
          height: auto;
          margin-right: 8px;
        }
      }
      .select-type {
        font-size: ${props => props.theme.font.small};
        font-weight: ${props => props.theme.fontW.medium};
      }
     .delete-btn {
        position: absolute;
        top: 50%;
        right: 10px;
        width: 24px;
        height: 24px;
        transform: translate(12px, -50%);
        &.chat-live-score {
          width: 30px;
          height: 30px;
        }
        .cls-ico {
          position: relative;
          display: block;
          transform: rotate(45deg);
          &::before, &::after {
            content:'';
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: ${props => props.theme.color.themeTxt};
          }
          &::before {
            width: 9px;
            height: 1px;
          }
          &::after {
            width: 1px;
            height: 9px;
          }
        }
      }
    }
    .match-status {
      z-index: 1;
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: calc(100% - 45px);
      height: 27px;
      font-size: ${props => props.theme.font.small};
      font-weight: ${props => props.theme.fontW.medium};
      color: ${props => props.theme.color.themeTxt};
      margin: 2px 0 0 5px;
      white-space: nowrap;
      &.close {
        color: ${props => props.theme.color.disableTxt2};
        margin-left: 0;
      }
      .live-spot {
        width: 9px;
        margin-right: 2px;
        margin-left: -8px;
        transform: translate3d(0, -1px, 0);
      }
    }
    .selected-match-body {
      flex: 1;
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: flex-start;
      width: 100%;
      height: auto;
      padding: 0 9px;
      .team-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 18px;
        line-height: 1.8rem;
        text-align: left;
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.small};
        position: relative;
        &:first-of-type {
          margin-bottom: 4px;
        }
        .team-name {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: ${props => props.theme.color.modalTxt};
          font-size: ${props => props.theme.font.small};
        }
        .team-emblem {
          width: 100%;
          max-width: 16px;
          height: auto;
          max-height: 16px;
          margin-right: 4px;
          &.icon {
            max-width: 14px;
            max-height: 14px;
            margin-left: 1px;
          }
        }
        .team-score {
          float: right;
          color: ${props => props.theme.color.modalTxt};
          margin-left: 4px;
          &.win {
            color: ${props => props.theme.color.red};
          }
        }
      } /* team-info */
      .match-state {
        width: auto;
        height: 4px;
        position: absolute;
        top: -2px;
        right: 0;
        display: flex;
        justify-content: flex-end;
        .circle {
          display: block;
          width: 3px;
          height: 3px;
          margin-left: 2px;
          border-radius: 50%;
          background: ${props => props.theme.color.modalTxt};
          opacity: .35;
        }
      }
      .plus-ico {
        position: relative;
        display: inline-block;
        width: 22px;
        height: 22px;
        margin: 0 auto;
        border-radius: 50%;
        border: 2px solid ${props => props.theme.color.red};
        &::before, &::after {
          content: '';
          display: block;
          position:absolute;
          top: 50%;
          left: 50%;
          transform: translate3d(-50%, -50%, 0) scale(1.6);
          background: ${props => props.theme.color.red};
          border-radius: 10px;
        }
        &::before {
          width: 7px;
          height: 1px;
        }
        &::after {
          width: 1px;
          height: 7px;
        }
      }
    } /* selected-match-body */
  } /* selected-match-item */
  .delete-all-btn {
    width: 100%;
    height: 30px;
    margin-top: -1px;
    color: ${props => props.theme.color.subBg};
    font-size: ${props => props.theme.font.small};
    font-weight: ${props => props.theme.fontW.medium};
    background: none;
    border-radius: 0;
    border: 1px solid #D7D9DC;
  }
`
